import React, {Component} from 'react';
import PropTypes from 'prop-types';
import urlHandler from '../../utils/urlHandler';
import validation from '../../utils/validation';
import data from '../../utils/data';
import ReactModal from 'react-modal';
import {Validators, FormBuilder, FieldControl, FieldGroup} from 'react-reactive-form';
import renderers from './forms/renderers';
import ArrayEditControl from './forms/ArrayEditControl';
import LocationEditControl from './forms/LocationEditControl';
import LinkEditControl from './forms/LinkEditControl';
import LinkEditControl2 from './forms/LinkEditControl2';
import LanguageFieldsEditControl from './forms/LanguageFieldsEditControl';
import PhoneNumbersEditControl from './forms/PhoneNumbersEditControl';
import EmailsEditControl from './forms/EmailsEditControl';
import IdentifiersEditControl from './forms/IdentifiersEditControl';
import CitizenshipsEditControl from './forms/CitizenshipsEditControl';

class CreateProgress extends Component {
    render() {
        return (
            <span className="kbedit-updating">
                <span className="fa fa-circle-o-notch fa-spin"></span>&nbsp;Creating ...
            </span>
        );
    }
}

class KbCreatePersonDialog extends Component {
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onReset = this.onReset.bind(this);
        this.onScrollTo = this.onScrollTo.bind(this);
        this.updateHeightDimensions = this.updateHeightDimensions.bind(this);
        this.initForm = this.initForm.bind(this);

        this.state = {
            height: 0,
            error: null,
            creating: false
        };
    };

    initForm() {
        this.myForm = FormBuilder.group({
            label: ['', Validators.required],
            description: ['', Validators.required],
            prominence: [0.50, Validators.required],
            nameVariations: FormBuilder.array(ArrayEditControl.initArray([]), {validators: [Validators.required]}),
            phoneNumbers: FormBuilder.array(PhoneNumbersEditControl.initArray([])),
            emails: FormBuilder.array(EmailsEditControl.initArray([])),
            givenNames: FormBuilder.array(ArrayEditControl.initArray([])),
            genders: FormBuilder.array(ArrayEditControl.initArray([])),
            nativeLanguages: FormBuilder.array(ArrayEditControl.initArray([])),
            ethnicGroups: FormBuilder.array(ArrayEditControl.initArray([])),
            fatherName: [''],
            motherName: [''],
            familyNames: FormBuilder.array(ArrayEditControl.initArray([])),
            spousesNames: FormBuilder.array(ArrayEditControl.initArray([])),
            partnersNames: FormBuilder.array(ArrayEditControl.initArray([])),
            childNames: FormBuilder.array(ArrayEditControl.initArray([])),
            siblingsNames: FormBuilder.array(ArrayEditControl.initArray([])),
            relativesNames: FormBuilder.array(ArrayEditControl.initArray([])),
            numberOfChildren: [''],
            attendedSchools: FormBuilder.array(LinkEditControl2.initArray([])),
            academicDegrees: FormBuilder.array(ArrayEditControl.initArray([])),
            sportsTeams: FormBuilder.array(LinkEditControl.initArray([])),
            sportAffiliations: FormBuilder.array(ArrayEditControl.initArray([])),
            sportsSpecialities: FormBuilder.array(ArrayEditControl.initArray([])),
            militaryBranches: FormBuilder.array(ArrayEditControl.initArray([])),
            militaryRanks: FormBuilder.array(ArrayEditControl.initArray([])),
            urls: FormBuilder.array(ArrayEditControl.initArray([], [Validators.pattern(validation.urlPattern)])),
            imageUrls: FormBuilder.array(ArrayEditControl.initArray([], [Validators.pattern(validation.urlPattern)])),
            citizenshipCountries: FormBuilder.array(ArrayEditControl.initArray([])),
            originCountry: [''],
            residenceLocation: FormBuilder.group(LocationEditControl.initLocation(null)),
            workFields: FormBuilder.array(ArrayEditControl.initArray([])),
            occupations: FormBuilder.array(ArrayEditControl.initArray([])),
            heldPositions: FormBuilder.array(ArrayEditControl.initArray([])),
            employers: FormBuilder.array(LinkEditControl2.initArray([])),
            ownedOrganizations: FormBuilder.array(LinkEditControl2.initArray([])),
            workLocation: FormBuilder.group(LocationEditControl.initLocation([])),
            birthName: [''],
            birthDate: ['', Validators.pattern(validation.datePattern)],
            birthLocation: FormBuilder.group(LocationEditControl.initLocation(null)),
            deathDate: ['', Validators.pattern(validation.datePattern)],
            deathCauses: FormBuilder.array(ArrayEditControl.initArray([])),
            deathLocation: FormBuilder.group(LocationEditControl.initLocation(null)),
            categories: FormBuilder.array(ArrayEditControl.initArray([])),
            contextKeywords: FormBuilder.array(ArrayEditControl.initArray([])),
            genres: FormBuilder.array(ArrayEditControl.initArray([])),
            partOf: FormBuilder.array(ArrayEditControl.initArray([])),
            religiousAffiliations: FormBuilder.array(ArrayEditControl.initArray([])),
            memberOf: FormBuilder.array(ArrayEditControl.initArray([])),
            politicalParties: FormBuilder.array(LinkEditControl.initArray([])),
            allegiances: FormBuilder.array(ArrayEditControl.initArray([])),
            languageFields: FormBuilder.array(LanguageFieldsEditControl.initArray([])),
            citizenships: FormBuilder.array(CitizenshipsEditControl.initArray([])),
            identifiers: FormBuilder.array(IdentifiersEditControl.initArray([])),
            userData: [''],
            document: ['', [Validators.required, Validators.minLength(250)]]
        });
    }

    componentDidMount() {
        ReactModal.setAppElement('#rm_KbCreatePersonDialog');
        this.updateHeightDimensions();
        this.initForm();
    }

    componentWillReceiveProps(newProps) {
        if (this.myForm) {
            this.initForm();
        }
    }

    updateHeightDimensions() {
        this.setState({
            height: window.innerHeight - 75 - (window.innerHeight / 5)
        })
    }

    close() {
        this.setState({
            creating: false,
            error: null
        },() => {
            if (this.props.onCreate) {
                this.props.onCreate();
            }
        })
    };

    onSubmit(e) {
        e.preventDefault();
        this.setState({
            creating: true
        }, ()=> {
            if (this.myForm.valid) {

                var formValues = Object.assign({}, this.myForm.getRawValue());

                // Sync the URL values with ID values. User doesn't see the ID values, only edits the URL values.
                validation.syncIdsWithUrls(formValues);

                // Remove all empty fields from the object
                validation.removeEmptyItems(formValues);
                
                if ('id' in formValues) {
                    delete formValues.id;
                }
                
                // The range slider editor will return string values when touched by the user. Not sure why? Convert back to float.
                if ('prominence' in formValues) {
                    formValues.prominence = parseFloat(formValues.prominence);
                }

                // Validate the user data is JSON
                if ('userData' in formValues && formValues.userData.length > 0) {
                    try {
                        formValues.userData = JSON.parse(formValues.userData);
                    } catch(ex) {
                        var msg = '';
                        if (ex instanceof SyntaxError) {
                            msg = 'SyntaxError: ' + ex.message;
                        } else {
                            msg = ex.message;                           
                        }
                        this.setState({
                            error: 'Invalid user data JSON value.\n' + msg,
                            creating: false
                        }, () => {
                            this.onScrollTo('err_msg');
                        })
                        return;
                    }
                }
                
                urlHandler.sendKbCreateRequest('PERSON', formValues, (resp, status) => {
                    if (status != 201) {
                        let error = decodeURIComponent(resp.error_message)
                        error = (error === undefined || error === 'undefined') ? '' : error;
                        if (!error && status == 504) {
                            error ='FFT Gateway timed out. Contact your administrator. Please try again later.' 
                        }
                        else if(!error) {
                            error = 'There was an error creating the person entity. Please try again later.';
                        }
                        this.setState({
                            error,
                            creating: false
                        }, () => {
                            this.onScrollTo('err_msg');
                        })   
                    } else {
                        this.close();
                    }
                })
            } else {
                this.setState({
                    error: 'There are errors below.',
                    creating: false
                }, () => {
                    this.onScrollTo('err_msg');
                })
            }
        });
    }

    onReset() {
        this.close();
    }

    onScrollTo(anchor) {
        document.getElementById(anchor).scrollIntoView({block: 'start', behavior: 'smooth'});
    }

    render() {
        var genders = data.getGenders();
        var countries = data.getCountries();
        var employerTypes = data.getEmployerTypes();
        var ownerTypes = data.getOwnerTypes();

        const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '0',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                paddingBottom: '5px',
                transform   : 'translate(-50%)',
                maxWidth    : '70%',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }

        return (
            <div id="rm_KbCreatePersonDialog">
                <ReactModal ref="createId" 
                    isOpen={this.props.show}
                    contentLabel="Create Person"
                    onRequestClose={this.close} 
                    style={styles}
                    shouldCloseOnOverlayClick={false}
                    closeTimeoutMS={1000}>
                    <div className="kbedit">
                        <div className="kbedit-header">
                            <span className="header-text">Create New Person</span>
                        </div> 

                        <div className="kbedit-content" style={{maxHeight: `${this.state.height}px`}}>

                        <div className="kbedit-controls-wrapper">
                            <div className="kbedit-static-menu">
                                <span onClick={() => {this.onScrollTo('bm_person_details')}}>Person Details</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_family_info')}}>Family Information</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_identifiers')}}>Identifiers</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_phone_numbers')}}>Phone Numbers</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_emails')}}>Emails</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_education_info')}}>Education Information</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_sports_info')}}>Sports Information</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_military_info')}}>Military Information</span><br/>            
                                <span onClick={() => {this.onScrollTo('bm_urls')}}>Urls</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_image_urls')}}>Image Urls</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_citizenship_info')}}>Citizenship Information</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_residence_info')}}>Residence Information</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_work_info')}}>Work Information</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_birth_info')}}>Birth Information</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_death_info')}}>Death Information</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_categories')}}>Categories</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_context_keywords')}}>Context Keywords</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_language_fields')}}>Language Fields</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_other_info')}}>Other Information</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_user_data')}}>User Data</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_document')}}>Document</span>
                            </div>
                            <div className="kbedit-controls-list">
                                {this.state.error &&
                                    <div className="kbedit-error" id="err_msg">
                                        {this.state.error}
                                    </div>
                                }

                                <FieldGroup
                                    control={this.myForm}
                                    render={({ pristine, value, invalid}) => (
                                        <div className="kbedit-nav-items">
                                            <div id="bm_person_details">
                                                <FieldControl name='label' render={renderers.textBox} meta={{label: 'Label', placeholder: 'Enter name'}}/>
                                                <FieldControl name='description' render={renderers.textArea} 
                                                    meta={{
                                                        label: 'Description', 
                                                        placeholder: 'Enter description',
                                                        height: '300px'
                                                    }}
                                                />
                                                <FieldControl name='prominence' render={renderers.rangeSlider} meta={{label: 'News Prominence'}}/>
                                                <ArrayEditControl name='nameVariations' label='Name Variations' addLabel="Add name variation" form={this.myForm}/>
                                                <ArrayEditControl name='givenNames' label='Given Names' addLabel="Add given name" form={this.myForm}/>
                                                <ArrayEditControl name='genders' label='Genders' addLabel="Add gender" form={this.myForm} items={genders}/>
                                                <ArrayEditControl name='nativeLanguages' label='Native Languages' addLabel="Add language" form={this.myForm}/>
                                                <ArrayEditControl name='ethnicGroups' label='Ethnic Groups' addLabel="Add ethnic group" form={this.myForm}/>                                                                                                                
                                            </div>
                                            <div id="bm_family_info">
                                                <FieldControl name='fatherName' render={renderers.textBox} 
                                                    meta={{
                                                        label: 'Father Name', 
                                                        placeholder: 'Enter name'
                                                    }}
                                                />
                                                <FieldControl name='motherName' render={renderers.textBox} 
                                                    meta={{
                                                        label: 'Mother Name', 
                                                        placeholder: 'Enter name'
                                                    }}
                                                />
                                                <ArrayEditControl name='familyNames' label='Family Names' addLabel="Add family name" form={this.myForm}/>
                                                <ArrayEditControl name='spousesNames' label='Spouses Names' addLabel="Add spouse name" form={this.myForm}/>
                                                <ArrayEditControl name='partnersNames' label='Partners Names' addLabel="Add partner name" form={this.myForm}/>
                                                <ArrayEditControl name='childNames' label='Child Names' addLabel="Add child name" form={this.myForm}/>
                                                <ArrayEditControl name='siblingsNames' label='Siblings Names' addLabel="Add sibling name" form={this.myForm}/>
                                                <ArrayEditControl name='relativesNames' label='Relatives Names' addLabel="Add relative name" form={this.myForm}/>
                                                <FieldControl name='numberOfChildren' render={renderers.numberBox} meta={{label: 'Number of Children'}}/>
                                            </div>
                                            <div id="bm_identifiers">
                                                <IdentifiersEditControl name='identifiers' label='Identifiers' addLabel="Add identifier" form={this.myForm}/>
                                            </div>
                                            <div id="bm_phone_numbers">
                                                <PhoneNumbersEditControl name='phoneNumbers' label='Phone Numbers' addLabel="Add phone" form={this.myForm}/>
                                            </div>
                                            <div id="bm_emails">
                                                <EmailsEditControl name='emails' label='Emails' addLabel="Add email" form={this.myForm} type="PERSON"/>
                                            </div>
                                            <div id="bm_education_info">
                                                <LinkEditControl2 name="attendedSchools" label="Attended Schools" addLabel="Add school" form={this.myForm}/>
                                                <ArrayEditControl name='academicDegrees' label='Academic Degrees' addLabel="Add degree" form={this.myForm}/>                                                    
                                            </div>
                                            <div id="bm_sports_info">
                                                <LinkEditControl name="sportsTeams" label="Sports Teams" addLabel="Add team" form={this.myForm}/>
                                                <ArrayEditControl name='sportAffiliations' label='Sport Affiliations' addLabel="Add affiliation" form={this.myForm}/>  
                                                <ArrayEditControl name='sportSpecialities' label='Sport Specialities' addLabel="Add sport speciality" form={this.myForm}/>
                                            </div>
                                            <div id="bm_military_info">
                                                <ArrayEditControl name='militaryBranches' label='Military Branches' addLabel="Add branch" form={this.myForm}/>  
                                                <ArrayEditControl name='militaryRanks' label='Military Ranks' addLabel="Add rank" form={this.myForm}/> 
                                            </div>
                                            <div id="bm_urls">
                                                <ArrayEditControl name='urls' label='Urls' 
                                                    addLabel="Add url" 
                                                    form={this.myForm} 
                                                    itemValidators={[Validators.pattern(validation.urlPattern)]}
                                                />
                                            </div>
                                            <div id="bm_image_urls">
                                                <ArrayEditControl name='imageUrls' 
                                                    label='Image Urls' 
                                                    addLabel="Add image url" 
                                                    form={this.myForm} 
                                                    itemValidators={[Validators.pattern(validation.urlPattern)]}
                                                    image={true}
                                                />
                                            </div>
                                            <div id="bm_citizenship_info">
                                                <CitizenshipsEditControl name="citizenships" label="Citizenships" addLabel="Add citizenship" form={this.myForm}/>
                                                <ArrayEditControl name='citizenshipCountries' 
                                                    label='Citizenship Countries' 
                                                    addLabel="Add country" 
                                                    form={this.myForm} 
                                                    items={countries}
                                                    itemsEditable={true}/>
                                                <FieldControl name='originCountry' render={renderers.comboBox} meta={{label: 'Origin Country', items: countries}}/>
                                            </div>
                                            <div id="bm_residence_info">
                                                <LocationEditControl name="residenceLocation" label="Residence Location" form={this.myForm}/>
                                            </div>
                                            <div id="bm_work_info">
                                                <ArrayEditControl name='workFields' label='Work Fields' addLabel="Add field" form={this.myForm}/>
                                                <ArrayEditControl name='occupations' label='Occupations' addLabel="Add occupation" form={this.myForm}/>
                                                <ArrayEditControl name='heldPositions' label='Held Positions' addLabel="Add position" form={this.myForm}/>
                                                <LinkEditControl2 name="employers" label="Employers" addLabel="Add employer" form={this.myForm} typeData={employerTypes}/>
                                                <LinkEditControl2 name="ownedOrganizations" label="Owned Organizations" addLabel="Add organization" form={this.myForm} typeData={ownerTypes}/>
                                                <LocationEditControl name="workLocation" label="Work Location" form={this.myForm}/>
                                            </div>
                                            <div id="bm_birth_info">
                                                <FieldControl name='birthName' render={renderers.textBox} meta={{label: 'Birth Name', placeholder: 'Enter name'}}/>  
                                                <FieldControl name='birthDate' render={renderers.textBox} meta={{label: 'Birth Date', placeholder: 'YYYY-MM-DD'}}/>
                                                <LocationEditControl name="birthLocation" label="Birth Location" form={this.myForm}/>
                                            </div>
                                            <div id="bm_death_info">
                                                <FieldControl name='deathDate' render={renderers.textBox} meta={{label: 'Death Date', placeholder: 'YYYY-MM-DD'}}/>
                                                <ArrayEditControl name='deathCauses' label='Death Causes' addLabel="Add death cause" form={this.myForm}/>
                                                <LocationEditControl name="deathLocation" label="Death Location" form={this.myForm}/>
                                            </div>
                                            <div id="bm_categories">
                                                <ArrayEditControl name='categories' label='Categories' addLabel="Add category" form={this.myForm}/>
                                            </div>
                                            <div id="bm_context_keywords">
                                                <ArrayEditControl name='contextKeywords' label='Context Keywords' addLabel="Add keyword" form={this.myForm} expanded={false}/>
                                            </div>
                                            <div id="bm_language_fields">
                                                <LanguageFieldsEditControl name="languageFields" label="Language Fields" addLabel="Add language field" form={this.myForm}/>
                                            </div>
                                            <div id="bm_other_info">
                                                <ArrayEditControl name='genres' label='Genres' addLabel="Add genre" form={this.myForm}/>
                                                <ArrayEditControl name='partOf' label='Part Of' addLabel="Add part of" form={this.myForm}/>
                                                <ArrayEditControl name='religiousAffiliations' label='Religious Affiliations' addLabel="Add religious affiliation" form={this.myForm}/>
                                                <ArrayEditControl name='memberOf' label='Member Of' addLabel="Add member of" form={this.myForm}/>
                                                <LinkEditControl name="politicalParties" label="Political Parties" addLabel="Add party" form={this.myForm}/>
                                                <ArrayEditControl name='allegiances' label='Allegiances' addLabel="Add allegiance" form={this.myForm}/>
                                            </div>
                                            <div id="bm_user_data">
                                                <FieldControl name='userData' render={renderers.textArea} 
                                                    meta={{
                                                        label: 'User Data (Valid JSON)', 
                                                        placeholder: 'Enter JSON',
                                                        height: '300px',
                                                        monospace: true,
                                                        expanded: false
                                                    }}
                                                />
                                            </div>
                                            <div id="bm_document">
                                                <FieldControl name='document' render={renderers.textArea} 
                                                    meta={{
                                                        label: 'Document', 
                                                        placeholder: 'Enter document',
                                                        height: '500px'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                />
                            </div>
                        </div>

                        </div>
                        <div className="kbedit-footer">
                            {this.state.creating ? <CreateProgress /> : null}
                            <button type="button" className="kbedit-default-button" onClick={this.onSubmit}>Create</button>
                            <button type="button" className="kbedit-default-button" onClick={this.onReset}>Cancel</button>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    };
}

KbCreatePersonDialog.propTypes = {
    show: PropTypes.bool.isRequired,
    onCreate: PropTypes.func
};

export default KbCreatePersonDialog;


